import { CapoPlugin } from "/home/raci_app/apps/default/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];